import { render, staticRenderFns } from "./PopularityOffersBanner.vue?vue&type=template&id=c5b3990c&"
import script from "./PopularityOffersBanner.vue?vue&type=script&lang=ts&"
export * from "./PopularityOffersBanner.vue?vue&type=script&lang=ts&"
import style0 from "./PopularityOffersBanner.vue?vue&type=style&index=0&id=c5b3990c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports